import * as TweenJS from "slotworks/utils/tween";
import { BounceZoomOut, EndlessHover } from "slotworks/graphics/animation/base-animations";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { CenterPivot, Ungroup } from "slotworks/graphics/pixi/group";
import Point from "slotworks/utils/geom/point";
import { sequence } from "slotworks/utils/race-utils";
import Contract from "slotworks/utils/contract";
import gameState from "slotworks/model/game-state";
import betModel from "slotworks/model/bets/bet-model";
import Components from "slotworks/components/components";
import Timer from "slotworks/utils/timer";
import WheelBonusRecord from "integration/records/wheel-bonus-record";

export default class RevolverWinTransitions extends AbstractSceneTransition {

    public HOVER_SCALE: number = 1.25;
    public HOVER_TIME: number = 300;

    protected valueHover: TweenJS.Tween<any>;
    protected value: PIXI.Text;

    protected timers: number[] = [];

    protected endlessHover() {
        this.valueHover = EndlessHover(this.value, this.HOVER_SCALE, this.HOVER_TIME);
    }

    public zoom(target: PIXI.Container,
        scaleFrom: number, scaleTo: number, duration: number, easing: (k: number) => number,
        pivot: Point = null): Contract<void> {

        return new Contract<void>((resolve) => {

            const group = CenterPivot(target, null, pivot);

            group.scale.set(scaleFrom, scaleFrom);

            const tween = new TweenJS.Tween(target.scale)
                .to({ x: scaleTo, y: scaleTo }, duration)
                .easing(easing);
            tween.onComplete(() => {
                tween.onComplete(null);
                Ungroup(group);
                target.scale.set(scaleTo, scaleTo);
                resolve(null);
            });
            tween.start();
        });
    }

    protected emphasizeValue() {
        return new Contract(resolve => {
            this.clearHover();
            new TweenJS.Tween(this.value.scale)
                .to({ x: 0.9, y: 0.9 }, 200)
                .onComplete(() => {
                    new TweenJS.Tween(this.value.scale)
                        .to({ x: 1.3, y: 1.3 }, 200)
                        .onComplete(() => {
                            resolve(null);
                        })
                        .start();
                })
                .start();
        })
    }

    protected zoomOutValue(delay: number = 0) {
        return new Contract(resolve => {
            this.clearHover();
            this.timers.push(Timer.setTimeout(() => {
                BounceZoomOut(this.value, 500).then(() => {
                    this.value.visible = false;
                    resolve(null);
                });
            }, delay));
        });
    }

    protected getWinLevel() {
        let winnings;
        const record = gameState.getCurrentGame().getCurrentRecord();
        if (gameState.getCurrentGame().inFreespinsGame) {
            winnings = gameState.getCurrentGame().totalFreespinsCreditsWon + gameState.getCurrentGame().recoveredFreeSpinTotalWin;
        } else if(record instanceof WheelBonusRecord && record.beenPaid) {
            winnings = record.totalCreditsWon;
        } else if (record.beenPaid) {
            winnings = gameState.getCurrentGame().totalCreditsWon;
        } else {
            winnings = record.creditsWon;
        }
        const stake = betModel.getTotalBet();

        const multiplier = winnings / stake;
        const selectedLevels: any[] = [];
        let tiers = Components.config.bigWin.tiers;
        for (const level of tiers) {
            if (level.threshold > multiplier) {
                break;
            } else {
                selectedLevels.push(level);
            }
        }
        return selectedLevels.length;
    }

    protected clearHover() {
        if (this.valueHover) {
            this.valueHover.stop();
            TweenJS.remove(this.valueHover);
            this.valueHover = null;
        }
    }

    protected clearTimers() {
        if (this.timers) {
            for (const timer of this.timers) {
                Timer.clearTimeout(timer);
            }
            this.timers = [];
        }
    }

}